export enum RuleVariant {
  THIN = 'thin',
  MEDIUM = 'medium',
  THICK = 'thick'
}
export enum RuleOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}
